import { apiRequestActions } from '@ackee/redux-utils';
import { fetchInvoicesTypes } from './types';

export default apiRequestActions(fetchInvoicesTypes);
